import { motion } from "framer-motion";
import { resolveUrl } from "../../lib/useCMS";

export const PageHero = ({ overline, heading, subheading, image, eyebrowChildren, dark = true }) => (
  <section className={`relative overflow-hidden ${dark ? "bg-[#0a0a0a]" : "bg-[#0f0f0f]"} pt-32 md:pt-40 pb-20 md:pb-28 border-b border-white/10`}>
    {image && (
      <div className="absolute inset-0">
        <img src={resolveUrl(image)} alt="" role="presentation" fetchPriority="high" decoding="async" className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black" />
      </div>
    )}
    <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)", backgroundSize: "80px 80px" }} />
    <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
      {overline && <p className="overline">{overline}</p>}
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="font-display text-white uppercase leading-[0.9] text-[clamp(2.5rem,8vw,7rem)] mt-5 tracking-tight max-w-5xl"
      >
        {heading}
      </motion.h1>
      {subheading && <p className="mt-6 text-lg md:text-xl text-zinc-300 max-w-2xl">{subheading}</p>}
      {eyebrowChildren && <div className="mt-8">{eyebrowChildren}</div>}
    </div>
  </section>
);
